module.exports = __webpack_public_path__ + "static/img/ent-detail-91.8d811e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-91.jpg
// module id = RQQD
// module chunks = 52